// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Overlay ── */
.lpm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1400;
}

/* ── Modal box ── */
.lpm-box {
  background: #fff;
  border-radius: 12px;
  width: 640px;
  max-width: 95vw;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  overflow: visible;
}

/* ── Header ── */
.lpm-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 14px;
  border-bottom: 1px solid #e8eaed;
}

.lpm-header-text {
  margin: 0;
  font-size: 13px;
  color: #555;
  font-weight: 400;
  line-height: 1.4;
}

.lpm-hl {
  font-weight: 600;
  color: #1a1a1a;
}

.lpm-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  color: #888;
  transition: background 0.15s, color 0.15s;
  flex-shrink: 0;
}
.lpm-close-btn:hover {
  background: #f0f0f0;
  color: #333;
}

/* ── Body ── */
.lpm-body {
  display: flex;
  gap: 20px;
  padding: 20px;
}

.lpm-left {
  flex: 0 0 200px;
  min-width: 0;
}

.lpm-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;
}

/* ── Section label ── */
.lpm-section-label {
  margin: 0 0 10px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #8a93a7;
}

/* ── Custom select ── */
.lpm-select-wrapper {
  position: relative;
}

.lpm-select-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1.5px solid #d1d5db;
  border-radius: 8px;
  padding: 8px 10px;
  cursor: pointer;
  background: #fff;
  min-height: 38px;
  transition: border-color 0.15s;
  user-select: none;
}
.lpm-select-trigger:hover {
  border-color: #a0aec0;
}

.lpm-select-value {
  font-size: 13px;
  color: #1a1a1a;
  font-weight: 500;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lpm-select-icons {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.lpm-icon-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px 4px;
  font-size: 11px;
  color: #888;
  border-radius: 4px;
  line-height: 1;
  transition: color 0.15s;
}
.lpm-icon-btn:hover {
  color: #333;
}

.lpm-chevron {
  font-size: 14px;
}

.lpm-divider {
  display: inline-block;
  width: 1px;
  height: 14px;
  background: #d1d5db;
  margin: 0 2px;
}

.lpm-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1.5px solid #d1d5db;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  z-index: 100;
  max-height: 220px;
  overflow-y: auto;
}

.lpm-dropdown-item {
  padding: 9px 12px;
  font-size: 13px;
  color: #2d3748;
  cursor: pointer;
  transition: background 0.1s;
}
.lpm-dropdown-item:hover {
  background: #f7fafc;
}
.lpm-dropdown-item--active {
  background: #eef2ff;
  color: #4361ee;
  font-weight: 600;
}

/* ── Preview card ── */
.lpm-preview-card {
  background: #f8f9fb;
  border-radius: 10px;
  padding: 14px 16px;
  border: 1px solid #e8eaed;
}

.lpm-preview-area {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100px;
}

.lpm-preview-label {
  border: 2px dashed #a0aec0;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  overflow: hidden;
  position: relative;
  transition: width 0.2s, height 0.2s;
}

.lpm-preview-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 6px 8px;
  gap: 2px;
  width: 100%;
}

.lpm-preview-customer {
  font-size: 9px;
  font-weight: 600;
  color: #4a5568;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.lpm-preview-product {
  font-size: 11px;
  font-weight: 700;
  color: #1a1a1a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.lpm-preview-variant {
  font-size: 9px;
  color: #718096;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.lpm-preview-divider {
  font-size: 8px;
  color: #a0aec0;
  letter-spacing: 0.02em;
  line-height: 1;
}

.lpm-preview-placeholder {
  text-align: center;
}
.lpm-preview-placeholder p {
  margin: 2px 0;
  font-size: 11px;
  color: #a0aec0;
}

/* ── Details ── */
.lpm-details {
  background: #f8f9fb;
  border-radius: 10px;
  padding: 12px 16px;
  border: 1px solid #e8eaed;
}

.lpm-detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12.5px;
  color: #555;
  padding: 4px 0;
  border-bottom: 1px solid #edf0f4;
}
.lpm-detail-row:last-child {
  border-bottom: none;
}

.lpm-detail-val {
  font-weight: 600;
  color: #1a1a1a;
}

/* ── Footer ── */
.lpm-footer {
  padding: 14px 20px 18px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #e8eaed;
}

.lpm-print-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #2563eb;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, opacity 0.15s;
}
.lpm-print-btn:hover:not(:disabled) {
  background: #1d4ed8;
}
.lpm-print-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* ── Dark mode ── */
.dark .lpm-box {
  background: #1e293b;
  color: #f1f5f9;
}

.dark .lpm-header {
  border-bottom-color: #334155;
}

.dark .lpm-header-text {
  color: #94a3b8;
}

.dark .lpm-hl {
  color: #f1f5f9;
}

.dark .lpm-close-btn {
  color: #94a3b8;
}
.dark .lpm-close-btn:hover {
  background: #334155;
  color: #f1f5f9;
}

.dark .lpm-section-label {
  color: #64748b;
}

.dark .lpm-select-trigger {
  background: #0f172a;
  border-color: #334155;
}
.dark .lpm-select-trigger:hover {
  border-color: #475569;
}

.dark .lpm-select-value {
  color: #f1f5f9;
}

.dark .lpm-icon-btn {
  color: #64748b;
}
.dark .lpm-icon-btn:hover {
  color: #cbd5e1;
}

.dark .lpm-divider {
  background: #334155;
}

.dark .lpm-dropdown {
  background: #1e293b;
  border-color: #334155;
}

.dark .lpm-dropdown-item {
  color: #e2e8f0;
}
.dark .lpm-dropdown-item:hover {
  background: #334155;
}
.dark .lpm-dropdown-item--active {
  background: #172554;
  color: #60a5fa;
}

.dark .lpm-preview-card {
  background: #0f172a;
  border-color: #334155;
}

.dark .lpm-preview-label {
  border-color: #475569;
  background: #1e293b;
}

.dark .lpm-preview-customer {
  color: #94a3b8;
}

.dark .lpm-preview-product {
  color: #f1f5f9;
}

.dark .lpm-preview-variant {
  color: #64748b;
}

.dark .lpm-preview-divider {
  color: #475569;
}

.dark .lpm-preview-placeholder p {
  color: #475569;
}

.dark .lpm-details {
  background: #0f172a;
  border-color: #334155;
}

.dark .lpm-detail-row {
  color: #94a3b8;
  border-bottom-color: #1e293b;
}

.dark .lpm-detail-val {
  color: #f1f5f9;
}

.dark .lpm-footer {
  border-top-color: #334155;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/delivery/components/LabelPrintModal/LabelPrintModal.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yCAAyC;EACzC,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,eAAe;AACf;EACE,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2CAA2C;AAC7C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* ── Overlay ── */\n.lpm-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1400;\n}\n\n/* ── Modal box ── */\n.lpm-box {\n  background: #fff;\n  border-radius: 12px;\n  width: 640px;\n  max-width: 95vw;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);\n  display: flex;\n  flex-direction: column;\n  overflow: visible;\n}\n\n/* ── Header ── */\n.lpm-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px 14px;\n  border-bottom: 1px solid #e8eaed;\n}\n\n.lpm-header-text {\n  margin: 0;\n  font-size: 13px;\n  color: #555;\n  font-weight: 400;\n  line-height: 1.4;\n}\n\n.lpm-hl {\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.lpm-close-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  color: #888;\n  transition: background 0.15s, color 0.15s;\n  flex-shrink: 0;\n}\n.lpm-close-btn:hover {\n  background: #f0f0f0;\n  color: #333;\n}\n\n/* ── Body ── */\n.lpm-body {\n  display: flex;\n  gap: 20px;\n  padding: 20px;\n}\n\n.lpm-left {\n  flex: 0 0 200px;\n  min-width: 0;\n}\n\n.lpm-right {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  min-width: 0;\n}\n\n/* ── Section label ── */\n.lpm-section-label {\n  margin: 0 0 10px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #8a93a7;\n}\n\n/* ── Custom select ── */\n.lpm-select-wrapper {\n  position: relative;\n}\n\n.lpm-select-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1.5px solid #d1d5db;\n  border-radius: 8px;\n  padding: 8px 10px;\n  cursor: pointer;\n  background: #fff;\n  min-height: 38px;\n  transition: border-color 0.15s;\n  user-select: none;\n}\n.lpm-select-trigger:hover {\n  border-color: #a0aec0;\n}\n\n.lpm-select-value {\n  font-size: 13px;\n  color: #1a1a1a;\n  font-weight: 500;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lpm-select-icons {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.lpm-icon-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 2px 4px;\n  font-size: 11px;\n  color: #888;\n  border-radius: 4px;\n  line-height: 1;\n  transition: color 0.15s;\n}\n.lpm-icon-btn:hover {\n  color: #333;\n}\n\n.lpm-chevron {\n  font-size: 14px;\n}\n\n.lpm-divider {\n  display: inline-block;\n  width: 1px;\n  height: 14px;\n  background: #d1d5db;\n  margin: 0 2px;\n}\n\n.lpm-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  background: #fff;\n  border: 1.5px solid #d1d5db;\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n  z-index: 100;\n  max-height: 220px;\n  overflow-y: auto;\n}\n\n.lpm-dropdown-item {\n  padding: 9px 12px;\n  font-size: 13px;\n  color: #2d3748;\n  cursor: pointer;\n  transition: background 0.1s;\n}\n.lpm-dropdown-item:hover {\n  background: #f7fafc;\n}\n.lpm-dropdown-item--active {\n  background: #eef2ff;\n  color: #4361ee;\n  font-weight: 600;\n}\n\n/* ── Preview card ── */\n.lpm-preview-card {\n  background: #f8f9fb;\n  border-radius: 10px;\n  padding: 14px 16px;\n  border: 1px solid #e8eaed;\n}\n\n.lpm-preview-area {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100px;\n}\n\n.lpm-preview-label {\n  border: 2px dashed #a0aec0;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff;\n  overflow: hidden;\n  position: relative;\n  transition: width 0.2s, height 0.2s;\n}\n\n.lpm-preview-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 6px 8px;\n  gap: 2px;\n  width: 100%;\n}\n\n.lpm-preview-customer {\n  font-size: 9px;\n  font-weight: 600;\n  color: #4a5568;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n.lpm-preview-product {\n  font-size: 11px;\n  font-weight: 700;\n  color: #1a1a1a;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n.lpm-preview-variant {\n  font-size: 9px;\n  color: #718096;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n.lpm-preview-divider {\n  font-size: 8px;\n  color: #a0aec0;\n  letter-spacing: 0.02em;\n  line-height: 1;\n}\n\n.lpm-preview-placeholder {\n  text-align: center;\n}\n.lpm-preview-placeholder p {\n  margin: 2px 0;\n  font-size: 11px;\n  color: #a0aec0;\n}\n\n/* ── Details ── */\n.lpm-details {\n  background: #f8f9fb;\n  border-radius: 10px;\n  padding: 12px 16px;\n  border: 1px solid #e8eaed;\n}\n\n.lpm-detail-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 12.5px;\n  color: #555;\n  padding: 4px 0;\n  border-bottom: 1px solid #edf0f4;\n}\n.lpm-detail-row:last-child {\n  border-bottom: none;\n}\n\n.lpm-detail-val {\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n/* ── Footer ── */\n.lpm-footer {\n  padding: 14px 20px 18px;\n  display: flex;\n  justify-content: flex-end;\n  border-top: 1px solid #e8eaed;\n}\n\n.lpm-print-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: #2563eb;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  padding: 10px 24px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s, opacity 0.15s;\n}\n.lpm-print-btn:hover:not(:disabled) {\n  background: #1d4ed8;\n}\n.lpm-print-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n/* ── Dark mode ── */\n.dark .lpm-box {\n  background: #1e293b;\n  color: #f1f5f9;\n}\n\n.dark .lpm-header {\n  border-bottom-color: #334155;\n}\n\n.dark .lpm-header-text {\n  color: #94a3b8;\n}\n\n.dark .lpm-hl {\n  color: #f1f5f9;\n}\n\n.dark .lpm-close-btn {\n  color: #94a3b8;\n}\n.dark .lpm-close-btn:hover {\n  background: #334155;\n  color: #f1f5f9;\n}\n\n.dark .lpm-section-label {\n  color: #64748b;\n}\n\n.dark .lpm-select-trigger {\n  background: #0f172a;\n  border-color: #334155;\n}\n.dark .lpm-select-trigger:hover {\n  border-color: #475569;\n}\n\n.dark .lpm-select-value {\n  color: #f1f5f9;\n}\n\n.dark .lpm-icon-btn {\n  color: #64748b;\n}\n.dark .lpm-icon-btn:hover {\n  color: #cbd5e1;\n}\n\n.dark .lpm-divider {\n  background: #334155;\n}\n\n.dark .lpm-dropdown {\n  background: #1e293b;\n  border-color: #334155;\n}\n\n.dark .lpm-dropdown-item {\n  color: #e2e8f0;\n}\n.dark .lpm-dropdown-item:hover {\n  background: #334155;\n}\n.dark .lpm-dropdown-item--active {\n  background: #172554;\n  color: #60a5fa;\n}\n\n.dark .lpm-preview-card {\n  background: #0f172a;\n  border-color: #334155;\n}\n\n.dark .lpm-preview-label {\n  border-color: #475569;\n  background: #1e293b;\n}\n\n.dark .lpm-preview-customer {\n  color: #94a3b8;\n}\n\n.dark .lpm-preview-product {\n  color: #f1f5f9;\n}\n\n.dark .lpm-preview-variant {\n  color: #64748b;\n}\n\n.dark .lpm-preview-divider {\n  color: #475569;\n}\n\n.dark .lpm-preview-placeholder p {\n  color: #475569;\n}\n\n.dark .lpm-details {\n  background: #0f172a;\n  border-color: #334155;\n}\n\n.dark .lpm-detail-row {\n  color: #94a3b8;\n  border-bottom-color: #1e293b;\n}\n\n.dark .lpm-detail-val {\n  color: #f1f5f9;\n}\n\n.dark .lpm-footer {\n  border-top-color: #334155;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
